/* eslint-disable */
import { ApiEndpoints } from "@shared/api/api-endpoints";
import { ixApiClient } from "@shared/api/clients/apiClientFactory";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

const setupConnection = async (payload: any): Promise<any> => {
  try {
    const url = ApiEndpoints.createUrl("ix", "connections/setup");
    const response = await ixApiClient.post(url, payload);
    return response.data.result || response.data;
  } catch (error) {
    throw error;
  }
};

const getChoices = async (
  remoteUtilityId: string,
  choiceType: string,
): Promise<any> => {
  try {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ix",
      `choices/${choiceType}`,
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        return query;
      },
    );
    const response = await ixApiClient.get(url);
    return response.data?.result;
  } catch (error) {
    throw error;
  }
};

const updateConnectionSetup = async (
  connectionId: string,
  payload: any,
): Promise<any> => {
  try {
    const url = ApiEndpoints.createUrl(
      "ix",
      `connections/${connectionId}/setup`,
    );
    const response = await ixApiClient.patch(url, payload);
    return response.data.result || response.data;
  } catch (error) {
    throw error;
  }
};

const editGetConnectionDetails = async (
  connectionId: string,
  remoteUtilityId: number | string,
): Promise<any> => {
  try {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ix",
      `connections/${connectionId}`,
      (query) => {
        if (remoteUtilityId) {
          query.push("remote_utility_id", remoteUtilityId);
        }
        return query;
      },
    );
    const response = await ixApiClient.get(url);
    return response?.data?.result || response?.data;
  } catch (error) {
    throw error;
  }
};

const getConnectorsCatalog = async (
  remoteUtilityId: number | string,
  family: string,
): Promise<any> => {
  try {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ix",
      `connectors/catalog`,
      (query) => {
        if (remoteUtilityId) {
          query.push("remote_utility_id", remoteUtilityId);
        }
        if (family) {
          query.push("family", family);
        }
        return query;
      },
    );
    const response = await ixApiClient.get(url);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const ixApi = {
  setupConnection,
  getChoices,
  updateConnectionSetup,
  editGetConnectionDetails,
  getConnectorsCatalog,
};
